'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory();
    } else if (typeof define !== 'undefined' && define.amd) {
        define('IOTP', [], function () {
            return factory();
        });
    } else {
        root.IOTP = factory();
    }
})(window || module || {}, function () {
    var IOTP = function () {
        function IOTP(value) {
            _classCallCheck(this, IOTP);

            this.value = '';

            if (value instanceof IOTP) {
                this.value = value.value;
            } else {
                this.value = String(value).replace(/\s+/g, '').replace(/-+/g, '');
            }

            return this;
        }

        /**
         * @param {number} maxlength
         * @return {boolean}
         */


        _createClass(IOTP, [{
            key: 'validate',
            value: function validate() {
                var maxlength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

                var reg = new RegExp('^[0-9]{' + maxlength + '}$');

                return reg.test(this.value);
            }

            /**
             * @param {object} options
             * @return {string}
             */

        }, {
            key: 'toString',
            value: function toString() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var code = this.value || '',
                    i = void 0,
                    len = code.length,
                    result = code,
                    separator = options.separator || '-',
                    separatedPartLength = options.separatedPartLength || 2;

                if (options.isNeedSeparated) {
                    for (i = 0; i < len; i = i + separatedPartLength) {
                        result += code.substring(i, separatedPartLength) + separator;
                    }

                    if (len % separatedPartLength !== 0) {
                        result += code.substring(len - len % separatedPartLength, len);
                    }
                }

                return result;
            }
        }, {
            key: 'is',
            value: function is() {
                console.warn('IOTP prototype.is() is deprecated.');
                return false;
            }

            /**
             * @return {string}
             */

        }, {
            key: 'toHtml',
            value: function toHtml() {
                console.warn('IOTP prototype.toHtml() is deprecated. Use .toString()');
                return this.toString();
            }
        }]);

        return IOTP;
    }();

    return IOTP;
});